import { Suspense } from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router'
import BackofficePage from '@/hoc/BackofficePage'
import routesConfig from './config'
import { SnackbarProvider } from 'baseui/snackbar'
import Home from '@/containers/HomePage'
import CarbonOffsets from '@/containers/CarbonOffsetManagement'
import Dashboard from '@/containers/DashboardPage'
import TelesalesForm from '@/containers/SubscriptionFormPage'
import SubscriptionForm from '@/containers/SubscriptionFormPageNew'
import ErrorPage from '@/containers/ErrorPage/ErrorPage'
import UsersManagement from '@/containers/UsersManagement'
import ServicesStatus from '@/containers/ServicesStatus'
import OfficesManagement from '@/containers/OfficesManagement'
import AssistanceProducts from '@/containers/AssistanceProductsManagement/AssistanceProducts'
import MonConseillerPersoProducts from '@/containers/MonConseillerPersoProductsManagement/MonConseillerPersoProducts'
import OrganizationRouter from '@/containers/OrganizationsManagement'
import ProviderOptionsManagement from '@/containers/ProviderOptionsManagement'
import DevTools from '@/containers/DevTools'
import IpAddressWhitelistManagement from '@/containers/IpAddressWhitelistManagement'
import { snackBarOverrides } from '@/containers/SubscriptionFormPage/ModulesPanel/styled-components'
import ClientCallbacksPage from '@/containers/ClientCallbacksPage'
import AdditionalProductsTools from '@/containers/AdditionalSalesManagement/AdditionalProductsTools'

const suspense = component => <Suspense fallback='loading'>{component}</Suspense>

const CustomRoutes = () => {
  return (
    <BrowserRouter
      future={{
        v7_relativeSplatPath: true,
      }}
    >
      <SnackbarProvider overrides={snackBarOverrides()}>
        <BackofficePage>
          <Routes>
            <Route path={routesConfig('home')} element={suspense(<Home />)} />
            <Route path={routesConfig('services-status')} element={suspense(<ServicesStatus />)} />
            <Route path={routesConfig('assistance-management')} element={suspense(<AssistanceProducts />)} />
            <Route
              path={routesConfig('mon-conseiller-perso-management')}
              element={suspense(<MonConseillerPersoProducts />)}
            />
            <Route path={routesConfig('carbon-offset')} element={suspense(<CarbonOffsets />)} />
            <Route
              path={routesConfig('subscriptions-list-telesales')}
              element={suspense(<Dashboard type='overview' />)}
            />
            <Route
              path={routesConfig('subscriptions-list-websales')}
              element={suspense(<Dashboard type='websales' />)}
            />
            <Route path={routesConfig('telesales-form')} element={suspense(<TelesalesForm />)} />
            <Route path={routesConfig('telesales-form-v2')} element={suspense(<SubscriptionForm />)} />
            <Route path={routesConfig('dev-tools')} element={suspense(<DevTools />)} />
            <Route path={routesConfig('organizations-management')} element={suspense(<OrganizationRouter />)} />
            <Route path={routesConfig('provider-options')} element={suspense(<ProviderOptionsManagement />)} />
            <Route path={routesConfig('users-management')} element={suspense(<UsersManagement />)} />
            <Route path={routesConfig('client-callbacks')} element={suspense(<ClientCallbacksPage />)} />
            <Route
              path={routesConfig('ip-addresses-management')}
              element={suspense(<IpAddressWhitelistManagement />)}
            />
            <Route path={routesConfig('offices-management')} element={suspense(<OfficesManagement />)} />
            <Route path={routesConfig('additional-products-management')} element={<AdditionalProductsTools />} />
            <Route path='' element={<Navigate to={routesConfig('home')} />} />
            <Route path='login' element={<Navigate to={routesConfig('home')} />} />
            <Route path='*' element={<ErrorPage />} />
          </Routes>
        </BackofficePage>
      </SnackbarProvider>
    </BrowserRouter>
  )
}

export default CustomRoutes
